import { ButtonVariants } from '../Atoms/Button';
import { If } from '../Atoms/Conditionals';
import { ButtonWithAnchor } from '../income-tax/page-sections/hero-section/sticky-button';
import { formatNumber } from './utils';

interface TaxRegimeRecommendationProps {
  taxDifference: number;
  suggestedTaxScheme: string;
}

export const TaxRegimeRecommendation = ({
  taxDifference,
  suggestedTaxScheme,
}: TaxRegimeRecommendationProps) => {
  return (
    <If condition={!!taxDifference}>
      <div className="flex justify-around items-center my-6 p-2 rounded-md bg-grey-150 sm:block">
        <div className="flex w-3/4 sm:w-full">
          <img
            className="w-6 h-6 mr-[14px] mt-1"
            src="https://assets.clear.in/cleartax/images/1721992734_bulb1.png"
            alt="bulb"
          />
          <div>
            <p className="text-green-400 text-s-20 md:text-s-18 leading-tight sm:text-s-14 sm:leading-snug">
              <span className="font-bold sm:text-s-14">
                {suggestedTaxScheme} Tax Regime
              </span>{' '}
              is recommended for you. It would save you ₹
              {formatNumber(taxDifference)} in taxes.
            </p>
          </div>
        </div>
        <div className="w-1/6 text-center sm:hidden">
          <ButtonWithAnchor
            buttonVariant={ButtonVariants.bluefilled}
            className={`w-full py-2 sm:w-3/4`}
            buttonText="File Now"
            trackLabel="tax-calculator-results-card-file-now"
            buttonLink="https://cleartax.in/filing?utm_ref=itr_2026_organic_content_pages_taxcalculator_new_file_now"
          />
        </div>
      </div>
    </If>
  );
};
